/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDetailsResource
 */
export interface OrganizationDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetailsResource
     */
    organizationName: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDetailsResource
     */
    whiteLabellingEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetailsResource
     */
    logoUrl?: string;
}

/**
 * Check if a given object implements the OrganizationDetailsResource interface.
 */
export function instanceOfOrganizationDetailsResource(value: object): value is OrganizationDetailsResource {
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('whiteLabellingEnabled' in value) || value['whiteLabellingEnabled'] === undefined) return false;
    return true;
}

export function OrganizationDetailsResourceFromJSON(json: any): OrganizationDetailsResource {
    return OrganizationDetailsResourceFromJSONTyped(json, false);
}

export function OrganizationDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'],
        'whiteLabellingEnabled': json['whiteLabellingEnabled'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function OrganizationDetailsResourceToJSON(value?: OrganizationDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationName': value['organizationName'],
        'whiteLabellingEnabled': value['whiteLabellingEnabled'],
        'logoUrl': value['logoUrl'],
    };
}

